import React from "react";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import { Col, Row } from "react-bootstrap";

export default function CategoryItemsList({
    categoryItems,
    onCategoryRemove,
    onCategoryInsert,
    onCategoryMoveUp,
    onCategoryMoveDown,
    onCategoryChange,
    onItemRemove,
    onItemInsert,
    onItemMoveUp,
    onItemMoveDown,
    onItemChange,
    onItemInfo,
}) {
    if (!categoryItems || categoryItems.length === 0) return null;

    return (
        <div className="mb-3">
            <Form.Label className="fw-semibold">Category Items</Form.Label>
            {categoryItems.map((categoryItem, idx) => (
                <div key={idx} className="mb-3 ps-2 border-start border-2">
                    <Row className="mb-2 align-items-center">
                        <Form.Group as={Col} md="7">
                            <Form.Control
                                type="text"
                                placeholder={`Category #${idx + 1} name`}
                                value={categoryItem.Category}
                                onChange={onCategoryChange(idx)}
                            />
                        </Form.Group>
                        <Form.Group as={Col} md="4" className="d-flex gap-1">
                            <Button type="button" size="sm" variant="outline-danger" onClick={onCategoryRemove(idx)}>−</Button>
                            <Button type="button" size="sm" variant="outline-secondary" onClick={onCategoryInsert(idx)}>+</Button>
                            <Button type="button" size="sm" variant="outline-secondary" onClick={onCategoryMoveUp(idx)}>↑</Button>
                            <Button type="button" size="sm" variant="outline-secondary" onClick={onCategoryMoveDown(idx)}>↓</Button>
                        </Form.Group>
                    </Row>

                    {categoryItem.ChallengeItems.map((challengeItem, idc) => (
                        <Row key={challengeItem.id ?? idc} className="mb-2 align-items-center ps-3">
                            <Form.Group as={Col} md="1">
                                <Button
                                    type="button"
                                    size="sm"
                                    onClick={() => onItemInfo(idx, idc, challengeItem)}
                                    variant={challengeItem.info ? "success" : "outline-primary"}
                                >
                                    info
                                </Button>
                            </Form.Group>
                            <Form.Group as={Col} md="6">
                                <Form.Control
                                    type="text"
                                    placeholder={`Item #${idc + 1}`}
                                    value={challengeItem.item}
                                    onChange={onItemChange(idx, idc)}
                                />
                            </Form.Group>
                            <Form.Group as={Col} md="4" className="d-flex gap-1">
                                <Button type="button" size="sm" variant="outline-danger" onClick={onItemRemove(idx, idc)}>−</Button>
                                <Button type="button" size="sm" variant="outline-secondary" onClick={onItemInsert(idx, idc)}>+</Button>
                                <Button type="button" size="sm" variant="outline-secondary" onClick={onItemMoveUp(idx, idc)}>↑</Button>
                                <Button type="button" size="sm" variant="outline-secondary" onClick={onItemMoveDown(idx, idc)}>↓</Button>
                            </Form.Group>
                        </Row>
                    ))}
                </div>
            ))}
        </div>
    );
}
